import {Component, Input} from '@angular/core';
import {avaliarRequisitosSenha, RequisitoSenhaItem} from "../../../../aplicacao/helper/validar-requisitos-senha.helper";

@Component({
  selector: 'app-requisitos-senha',
  templateUrl: './requisitos-senha.component.html',
  styleUrls: ['./requisitos-senha.component.scss']
})
export class RequisitosSenhaComponent {
  requisitos: RequisitoSenhaItem[] = avaliarRequisitosSenha('');

  @Input() titulo = 'A senha deve ter pelo menos';

  @Input() set senha(value: string) {
    this.requisitos = avaliarRequisitosSenha(value);
  }
}

